import { createFileRoute } from "@tanstack/react-router";
import SEOAudit from "@/pages/SEOAudit";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/seo-audit/")({
  head: () => routeHead("/de/seo-audit/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SEOAudit />
  );
}
